var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container content-padding" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.statement && _vm.statement.length
        ? [
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "col-12 table-responsive" }, [
                _c(
                  "table",
                  {
                    staticClass: "table table-striped",
                    staticStyle: { "font-size": "85%" }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.statement, function(record, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            class: { "text-success": record.amount < 0 }
                          },
                          [
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(_vm._s(index + 1))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("prettyOnlyDate")(record.created_at)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(_vm._s(record.detail))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(record.amount))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(record.remain))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ])
            ])
          ]
        : [_vm._m(2)]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", [_vm._v("Statement ยอดหนี้คงเหลือ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("วันที่ทำรายการ")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("รายการ")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("ยอดหนี้")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("คงเหลือ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", { staticClass: "text-muted" }, [_vm._v("ไม่มีรายการ")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2543f182", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2543f182","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/ProfessionalDebt.vue
// module id = 1987
// module chunks = 0